/* eslint-disable arrow-body-style */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';

import './RuleDetails.css';

const commonMessages = {
  agentIs: 'When agent is',
  agentIsNot: 'When agent is not',
  duringContainer: 'During container',
  notDuringContainer:'Not during container',
  duringSegment: 'During segment',
  notDuringSegment: 'Not during segment',
  notApplicable: 'Not Applicable',
  empty: '(empty)',
  NA: 'N/A',
  all: 'All'
};

const DisabledClass = 'disabled';

const RuleDetails = ({ data }) => {
  const { rowData } = data;

  const setMessage = () => !rowData.Site && rowData.Client ? commonMessages.all : commonMessages.NA;

  return (
    <div className='rule__details__wrapper'>
      <div className='rule__details__container'>
        <p className='rule__details__title'>CPP</p>
        <div className='rule__details__box'>
          <div className='rule__details__box__wrapper details__bold'>
            <p>Rule Name </p>
            <p>Client </p>
            <p>Program </p>
            <p>Project </p>
            <p>Site </p>
          </div>
          <div className='rule__details__box__wrapper'>
            <p>{rowData.RuleName}</p>
            <p>{rowData.Client ? rowData.Client.DescriptionShort : commonMessages.NA}</p>
            <p>{rowData.Program ? rowData.Program.DescriptionShort : commonMessages.NA}</p>
            <p>{rowData.Project ? rowData.Project.DescriptionShort : commonMessages.NA}</p>
            <p>{rowData.Site ? rowData.Site.DescriptionShort : setMessage()}</p>
          </div>
        </div>
      </div>
      <div className='rule__details__container' >
        <p className='rule__details__title'>Dimensions</p>
        <div className='rule__details__box'>
          <div className='rule__details__box__wrapper details__bold'>
            <p>Alarm Type </p>
            <p>{rowData.IncludeACDStatus ? commonMessages.agentIs : commonMessages.agentIsNot}</p>
            <p>{rowData.IncludeContainer ? commonMessages.duringContainer : commonMessages.notDuringContainer}</p>
            <p>{rowData.IncludeSegment ? commonMessages.duringSegment : commonMessages.notDuringSegment}</p>
          </div>
          <div className='rule__details__box__wrapper'>
            <p>{rowData.AlertType.Description}</p>
            <p>{rowData.ACDStatus ?? commonMessages.notApplicable}</p>
            <p>{rowData.ScheduleContainerCode ?? commonMessages.NA}</p>
            <p>{rowData.ScheduleSegmentCode ?? commonMessages.NA}</p>
          </div>
        </div>
      </div>
      <div className='rule__details__container' >
      <p className='rule__details__title'>Tagging and flagging</p>
        <div className='rule__details__box'>
          <div className='rule__details__box__wrapper details__bold'>
            <p>Tag </p>
            <p>Tag Duration </p>
            <p>Minimum Threshold (in minutes) </p>
            <p>Maximum Threshold (in minutes) </p>
            <p>Flag Frequency (in minutes) </p>
            <p>Historical Notes </p>
            <p className={rowData.NotifyAgent === 1 ? '' : DisabledClass}>User to be notified: </p>
            <p className={rowData.NotifyAgent === 1 ? '' : DisabledClass}>Notification text: </p>
            <p className={rowData.NotifyGA === 1 ? '' : DisabledClass}>User to be notified: </p>
            <p className={rowData.NotifyGA === 1 ? '' : DisabledClass}>Notification text: </p>
            <p>Zoom Channel: </p>
          </div>
          <div className='rule__details__box__wrapper'>
            <p>{rowData.TagScheduleSegmentCode ?? commonMessages.NA}</p>
            <p>{rowData.TagDuration ?? commonMessages.NA}</p>
            <p>{rowData.MinThreshold / 60}</p>
            <p>{rowData.MaxThreshold / 60}</p>
            <p>{rowData.FlagFrequency ?? commonMessages.NA}</p>
            <p>{rowData.HistoricalNotes !== '' && rowData.HistoricalNotes ? rowData.HistoricalNotes : commonMessages.empty}</p>
            <p className={rowData.NotifyAgent === 1 ? '' : DisabledClass}>Agent</p>
            <p className={rowData.NotifyAgentText ? '' : DisabledClass}>{rowData.NotifyAgentText}</p>
            <p className={rowData.NotifyGA === 1 ? '' : DisabledClass}>G&A</p>
            <p className={rowData.NotifyGAText ? '' : DisabledClass}>{rowData.NotifyGAText}</p>
            <p>{rowData.ZoomChannel ? rowData.ZoomChannel.Name : commonMessages.empty}</p>
          </div>
        </div>
      </div>
    </div>
  )
};

RuleDetails.propTypes = {
  data: PropTypes.object.isRequired,
};

export default RuleDetails
